
export const data = [
    {
        id: 0,
        employeeName: "Mehroz",
        accountNo: 1,
        grossSalary: 1,
        increment: 1,
        bonus: 1,
        advance: 1,
        deduction: 1,
        netSalary: 1,
        comments: "A",

    },
    {
        id: 1,
        employeeName: "Usama",
        accountNo: 2,
        grossSalary: 2,
        increment: 2,
        bonus: 2,
        advance: 2,
        deduction: 2,
        netSalary: 2,
        comments: "B"
    },
    {
        id: 2,
        employeeName: "Faizan",
        accountNo: 3,
        grossSalary: 3,
        increment: 3,
        bonus: 3,
        advance: 3,
        deduction: 3,
        netSalary: 3,
        comments: "C"
    },
    {
        id: 3,
        employeeName: "Ayaz",
        accountNo: 4,
        grossSalary: 4,
        increment: 4,
        bonus: 4,
        advance: 4,
        deduction: 4,
        netSalary: 4,
        comments: "D"
    },
    {
        id: 4,
        employeeName: "Umer",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 5,
        employeeName: "Usama Ikram",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 6,
        employeeName: "Zahid",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 7,
        employeeName: "Irfan Malik",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 8,
        employeeName: "Hamza",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 9,
        employeeName: "Nawaz",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 10,
        employeeName: "Irfan Malik",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 11,
        employeeName: "Hamza",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    },
    {
        id: 12,
        employeeName: "Nawaz",
        accountNo: 5,
        grossSalary: 5,
        increment: 5,
        bonus: 5,
        advance: 5,
        deduction: 5,
        netSalary: 5,
        comments: "E"
    }
]
